import React, { useRef, useEffect } from "react";
import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import { useTranslation } from "react-i18next";

gsap.registerPlugin(ScrollTrigger);

const ChiSono = () => {
  const sectionRef = useRef(null);
  const { t } = useTranslation();

  useEffect(() => {
    const el = sectionRef.current;

    gsap.utils.toArray(el.querySelectorAll(".fade-up")).forEach((item) => {
      gsap.fromTo(
        item,
        { opacity: 0, y: 40, scale: 0.98 },
        {
          opacity: 1,
          y: 0,
          scale: 1,
          duration: 1.2,
          ease: "power3.out",
          scrollTrigger: {
            trigger: item,
            start: "top 85%",
            toggleActions: "play none none reverse"
          }
        }
      );
    });
  }, []);

  return (
    <section
      id="chisono"
      ref={sectionRef}
      className="relative w-full py-32 bg-gradient-to-b from-slate-300 via-white to-slate-50 overflow-hidden font-Crimson text-slate-800"
    >
      <div className="absolute inset-0 bg-gradient-to-r from-[#B1C1B3]/20 via-[#D0ACA8]/10 to-[#537074]/20 opacity-70 blur-3xl"></div>

      <div className="relative max-w-6xl mx-auto px-6 flex flex-col md:flex-row items-center justify-center gap-16 z-10">
        <div className="relative fade-up">
          <div className="w-52 h-52 md:w-80 md:h-80 rounded-full overflow-hidden shadow-2xl border-4 border-white/80 relative">
            <img
              src="/img/foto_profilo.jpg"
              alt="Naim Lopez"
              className="object-cover w-full h-full"
            />
            <div className="absolute inset-0 rounded-full bg-gradient-to-r from-[#537074] via-[#D0ACA8] to-[#B1C1B3] opacity-40 animate-spin-slow"></div>
          </div>
        </div>

        <div className="fade-up text-center md:text-left max-w-xl space-y-6">
          <h2 className="text-4xl md:text-5xl font-semibold text-[#537074] mb-4">
            {t("chiSono.title")}
          </h2>
          <p className="text-lg leading-relaxed text-slate-700/90">
            {t("chiSono.body1")}
          </p>
          <p className="text-lg leading-relaxed text-slate-700/90">
            {t("chiSono.body2")}
          </p>
        </div>
      </div>
    </section>
  );
};

export default ChiSono;
